import { BaseRestResource } from '@snap-alex/domain-js';
import { fileResourceUrl } from '../constants';
import { httpResource } from 'core/resources/httpResource';

class FileResource extends BaseRestResource {}

export const fileResource = new FileResource(httpResource, fileResourceUrl);
